import { isProduction } from './isProduction';

export function shouldShowAutoFill(): boolean {
  return !isProduction() || import.meta.env.VITE_TENANT_ID === 'DEMO';
}
